/* Made-to-measure curtain configurator.

   standard                 matches a real variant, shows its price
   custom / custom-verify   buy the Custom variant at a calculated price
   pro-measure              buys the measuring visit product

   The pricing function redoes the sum server-side and that is what gets
   charged. Everything here is just so there is a number on screen. */
(function () {
  'use strict';

  var SIZE_PARAM = 'cc-size';
  var HEADING_PARAM = 'cc-heading';
  var CM_PER_INCH = 2.54;
  //var PRICE_ROUND_TO = 10; // must match pricing.js's PRICE_ROUND_TO exactly

  /** Format cents using the shop's money format string. */
  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;

    function withDelimiters(decimals, thousands, decimal) {
      var fixed = value.toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 && parts[1] ? whole + decimal + parts[1] : whole;
    }

    return String(format || '{{amount}}').replace(
      /\{\{\s*(\w+)\s*\}\}/,
      function (_match, token) {
        switch (token) {
          case 'amount_no_decimals':
            return withDelimiters(0, ',', '.');
          case 'amount_with_comma_separator':
            return withDelimiters(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return withDelimiters(0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return withDelimiters(2, "'", '.');
          case 'amount_with_space_separator':
            return withDelimiters(2, ' ', ',');
          case 'amount_no_decimals_with_space_separator':
            return withDelimiters(0, ' ', ',');
          default:
            return withDelimiters(2, ',', '.');
        }
      }
    );
  }

  function parseJSON(root, selector, fallback) {
    var el = root.querySelector(selector);
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[curtain-configurator] could not parse ' + selector, e);
      return fallback;
    }
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  /* "Name = value" per line -> lookup. */
  function parseMap(text) {
    var out = {};
    String(text || '').split('\n').forEach(function (line) {
      var parts = line.split('=');
      if (parts.length < 2) return;
      var key = parts[0].trim();
      var value = parseFloat(parts[1]);
      if (key && Number.isFinite(value)) out[key] = value;
    });
    return out;
  }

  /**
   * Same sum as pricing.js in the app. Keep the two in step.
   *
   *   panels = ROUNDUP((width_mm + return) x fullness / roll_width_mm)
   *   metres = panels x (drop_mm + hem) / 1000
   *   price  = (rate x metres + track_rate x max(min, width_m) + install) x markup
   *
   * Null when we cannot price it, and the caller then shows nothing.
   */
  function priceCurtain(cfg, widthCm, dropCm, heading) {
    if (!cfg) return null;
    if (!Number.isFinite(widthCm) || !Number.isFinite(dropCm)) return null;

    var fullness = parseMap(cfg.fullness)[heading];
    var trackRate = parseMap(cfg.trackRate)[heading];
    if (!fullness || !trackRate) return null;

    var rollWidthMm = parseFloat(cfg.rollWidthMm);
    var ratePerMetre = parseFloat(cfg.ratePerMetre);
    if (!(rollWidthMm > 0) || !(ratePerMetre > 0)) return null;

    var panels = Math.ceil(((widthCm * 10 + Number(cfg.returnMm)) * fullness) / rollWidthMm);
    var metres = (panels * (dropCm * 10 + Number(cfg.hemMm))) / 1000;
    var track = trackRate * Math.max(parseFloat(cfg.trackMinM), widthCm / 100);
    var price = Math.round(((ratePerMetre * metres + track + Number(cfg.installation)) * parseFloat(cfg.markup)) / 10) * 10;
    //var rawPrice = (ratePerMetre * metres + track + Number(cfg.installation)) * parseFloat(cfg.markup);
    // Rounded to the nearest 10, matching pricing.js exactly — the number
    // shown here has to agree with what actually gets charged.
    //var price = Math.round(rawPrice / PRICE_ROUND_TO) * PRICE_ROUND_TO;

    return Number.isFinite(price) && price > 0 ? price : null;
  }

  function CurtainConfigurator(root) {
    this.root = root;
    this.variants = parseJSON(root, '[data-cc-variants]', []);
    this.config = parseJSON(root, '[data-cc-config]', {});

    this.variantInput = root.querySelector('[data-cc-variant-input]');
    this.qtyInput = root.querySelector('[data-cc-qty-input]');
    this.serviceInput = root.querySelector('[data-cc-service-input]');
    this.priceEls = root.querySelectorAll('[data-cc-price]');
    this.compareEl = root.querySelector('[data-cc-compare-price]');
    this.totalCompareEl = root.querySelector('[data-cc-total-compare]');
    this.totalEl = root.querySelector('[data-cc-total]');
    this.submitBtn = root.querySelector('[name="add"]');
    this.submitText = root.querySelector('[data-cc-submit-text]');
    this.summarySize = root.querySelector('[data-cc-summary-size]');
    this.summaryHeading = root.querySelector('[data-cc-summary-heading]');
    this.summaryService = root.querySelector('[data-cc-summary-service]');
    this.summaryTitle = root.querySelector('[data-cc-summary-title]');
    this.enquiryForm = root.querySelector('.cc-enquiry__form');
    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-cc-option-group]'));

    this.path = 'custom';
    this.unit = 'cm';
    this.quantity = 1;
    this.slot = 'Any';

    if (!this.variants.length || !this.variantInput) return;

    this.applyUrlPreselection();
    this.bind();
    this.setupVisitDates();
    this.setPath('custom');
    this.render();
  }

  /* ----------------------------------------------------------- preselection */

  CurtainConfigurator.prototype.applyUrlPreselection = function () {
    var params = new URLSearchParams(window.location.search);
    var wanted = {};
    wanted[this.config.sizeIndex] = params.get(SIZE_PARAM);
    wanted[this.config.headingIndex] = params.get(HEADING_PARAM);

    this.groups.forEach(function (group) {
      var index = Number(group.getAttribute('data-cc-option-index'));
      var value = wanted[index];
      if (!value) return;
      // Match on value: the option values contain brackets we would escape.
      group.querySelectorAll('[data-cc-option-input]').forEach(function (input) {
        if (input.value === value) input.checked = true;
      });
    });
  };

  /* ------------------------------------------------------------------ events */

  CurtainConfigurator.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('change', function (evt) {
      if (evt.target.matches('[data-cc-option-input]')) self.render();
      if (evt.target.matches('[data-cc-visit]')) self.render();
    });

    this.root.addEventListener('input', function (evt) {
      if (evt.target.matches('[data-cc-dim-number]')) self.onDimensionInput(evt.target, 'number');
      if (evt.target.matches('[data-cc-dim-slider]')) self.onDimensionInput(evt.target, 'slider');
    });

    this.root.addEventListener('click', function (evt) {
      var thumb = evt.target.closest('[data-cc-thumb]');
      if (thumb) return self.showImage(thumb.getAttribute('data-cc-full'), thumb);

      // NEW: panel style (Single/Pair) isn't a variant, so it's handled
      // directly here rather than through the data-cc-option-group flow.
      var panelStyle = evt.target.closest('[data-cc-panel-style]');
      if (panelStyle) return self.setPanelStyle(panelStyle.getAttribute('data-cc-panel-style'));

      var tab = evt.target.closest('[data-cc-path]');
      if (tab) return self.setPath(tab.getAttribute('data-cc-path'));

      var unit = evt.target.closest('[data-cc-unit]');
      if (unit) return self.setUnit(unit.getAttribute('data-cc-unit'));

      var slot = evt.target.closest('[data-cc-slot]');
      if (slot) return self.setSlot(slot.getAttribute('data-cc-slot'));

      var step = evt.target.closest('[data-cc-qty-step]');
      if (step) return self.stepQuantity(Number(step.getAttribute('data-cc-qty-step')));
    });

    // The sizing rows are now plain divs (role="radio"), not <button>s —
    // matching the real component, and needed so the "How to measure" link
    // can nest inside one without invalid nested-button HTML. Divs don't
    // get Enter/Space activation for free the way buttons do, so wire it up
    // here. Guarded to the row itself (not a descendant) so it doesn't
    // interfere with the nested measure-link's own native keyboard handling.
    this.root.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ' && evt.key !== 'Spacebar') return;
      if (evt.target.matches('[data-cc-path]')) {
        evt.preventDefault();
        self.setPath(evt.target.getAttribute('data-cc-path'));
      }
    });

    if (this.enquiryForm) {
      this.enquiryForm.addEventListener('submit', function () {
        self.fillEnquiry();
      });
    }

    this.revealEnquiryConfirmation();
  };

  /* The reload resets the path to standard and would hide the confirmation
     with it, so force it open. */
  CurtainConfigurator.prototype.revealEnquiryConfirmation = function () {
    var success = this.root.querySelector('[data-cc-enquiry-success]');
    if (!success) return;

    var wrapper = this.root.querySelector('.cc-enquiry');
    if (wrapper) wrapper.hidden = false;
    success.scrollIntoView({ block: 'center', behavior: 'smooth' });
    success.focus();
  };

  /* ------------------------------------------------------------------- paths */

  CurtainConfigurator.prototype.setPath = function (path) {
    this.path = path;
var priceNote = this.root.querySelector('[data-cc-price-note]');

if (priceNote) {
  priceNote.style.display = path === 'pro-measure' ? 'none' : '';
}
    this.root.querySelectorAll('[data-cc-path]').forEach(function (tab) {
      var on = tab.getAttribute('data-cc-path') === path;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    this.root.querySelectorAll('[data-cc-panel]').forEach(function (panel) {
      var on = panel.getAttribute('data-cc-panel') === path;
      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
    });

    // Elements that only apply to some paths.
    this.root.querySelectorAll('[data-cc-show-for]').forEach(function (el) {
      el.hidden = el.getAttribute('data-cc-show-for').split(' ').indexOf(path) === -1;
    });
    this.root.querySelectorAll('[data-cc-hide-for]').forEach(function (el) {
      el.hidden = el.getAttribute('data-cc-hide-for').split(' ').indexOf(path) !== -1;
    });

    // renderMeasureVisit may override this, so reset it from the path first.
    var enquiry = this.root.querySelector('.cc-enquiry');
    if (enquiry) {
      enquiry.hidden = enquiry.getAttribute('data-cc-show-for').split(' ').indexOf(path) === -1;
    }

    if (this.serviceInput && this.config.serviceLabels) {
      this.serviceInput.value = this.config.serviceLabels[path] || '';
    }
    if (this.summaryTitle && this.config.summaryTitles) {
      this.summaryTitle.textContent = this.config.summaryTitles[path] || 'Your design';
    }

    this.renumberSteps();
    this.render();
  };

  /* Step numbers react to what's actually visible: hiding Heading/Operation/
     Installation for "pro-measure" should pull the visit-time step's number
     down (e.g. Step 5 -> Step 2), matching the real design. Walks every
     .cc-step in DOM order and numbers only the ones not currently hidden. */
  CurtainConfigurator.prototype.renumberSteps = function () {
    var n = 0;
    this.root.querySelectorAll('.cc-step').forEach(function (step) {
      if (step.hidden) return;
      n += 1;
      var marker = step.querySelector('[data-cc-step-index]');
      if (marker) marker.textContent = n;
    });
  };

  /* -------------------------------------------------------------- dimensions */

  CurtainConfigurator.prototype.setUnit = function (unit) {
    if (unit === this.unit) return;
    this.unit = unit;

    this.root.querySelectorAll('[data-cc-unit]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-cc-unit') === unit);
    });
    this.root.querySelectorAll('[data-cc-dim-unit]').forEach(function (el) {
      el.textContent = unit === 'in' ? 'in' : 'cm';
    });

    var self = this;
    this.root.querySelectorAll('[data-cc-dim]').forEach(function (wrap) {
      self.paintDimension(wrap);
    });
    this.paintSizeDims();
  };

  /* Standard-size cards show "W CM Width  ·  H CM Drop" as plain text (not
     an editable input), so the cm/in toggle repaints them separately here. */
  CurtainConfigurator.prototype.paintSizeDims = function () {
    var self = this;
    this.root.querySelectorAll('[data-cc-size-dims]').forEach(function (el) {
      var wCm = Number(el.getAttribute('data-cc-size-w-cm'));
      var hCm = Number(el.getAttribute('data-cc-size-h-cm'));
      if (!wCm || !hCm) return;
      var unitLabel = self.unit === 'in' ? 'IN' : 'CM';
      el.textContent = self.toDisplay(wCm) + ' ' + unitLabel + ' Width  ·  ' + self.toDisplay(hCm) + ' ' + unitLabel + ' Drop';
    });
  };

  /** Convert a cm value into whatever unit is on display. */
  CurtainConfigurator.prototype.toDisplay = function (cm) {
    return this.unit === 'in' ? Math.round((cm / CM_PER_INCH) * 10) / 10 : Math.round(cm);
  };

  CurtainConfigurator.prototype.toCm = function (display) {
    return this.unit === 'in' ? Math.round(display * CM_PER_INCH) : Math.round(display);
  };

  CurtainConfigurator.prototype.onDimensionInput = function (input, source) {
    var wrap = input.closest('[data-cc-dim]');
    if (!wrap) return;

    var number = wrap.querySelector('[data-cc-dim-number]');
    var min = Number(number.getAttribute('data-cc-min-cm'));
    var max = Number(number.getAttribute('data-cc-max-cm'));

    var cm;
    if (source === 'slider') {
      cm = Number(input.value);
    } else {
      var raw = Number(input.value);
      if (input.value === '' || Number.isNaN(raw)) return; // mid-typing, leave alone
      cm = this.toCm(raw);
    }

    number.setAttribute('data-cc-value-cm', clamp(cm, min, max));
    this.paintDimension(wrap, source === 'number');
    this.render();
  };

  /** Push the stored cm value back out into the number box and slider. */
  CurtainConfigurator.prototype.paintDimension = function (wrap, skipNumber) {
    var number = wrap.querySelector('[data-cc-dim-number]');
    var slider = wrap.querySelector('[data-cc-dim-slider]');
    var minCm = Number(number.getAttribute('data-cc-min-cm'));
    var maxCm = Number(number.getAttribute('data-cc-max-cm'));
    var cm = Number(number.getAttribute('data-cc-value-cm'));

    if (!skipNumber) {
      number.value = this.toDisplay(cm);
      number.min = this.toDisplay(minCm);
      number.max = this.toDisplay(maxCm);
      number.step = this.unit === 'in' ? 0.1 : 1;
    }
    if (slider) slider.value = cm;

    var minEl = wrap.querySelector('[data-cc-dim-min]');
    var maxEl = wrap.querySelector('[data-cc-dim-max]');
    if (minEl) minEl.textContent = this.toDisplay(minCm);
    if (maxEl) maxEl.textContent = this.toDisplay(maxCm);
  };

  CurtainConfigurator.prototype.dimensionCm = function (id) {
    var number = this.root.querySelector('[data-cc-dim="' + id + '"] [data-cc-dim-number]');
    return number ? Number(number.getAttribute('data-cc-value-cm')) : null;
  };

  /* ----------------------------------------------------------------- booking */
// added by rabana
CurtainConfigurator.prototype.setupVisitDates = function () {
  var preferredInput = this.root.querySelector('[data-cc-visit="preferred"]');
  var alternateInput = this.root.querySelector('[data-cc-visit="alternate"]');

  if (!preferredInput || !alternateInput) return;

  function formatDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');

    return year + '-' + month + '-' + day;
  }

  function updateDateNote(input) {
    var field = input.closest('[data-cc-date-field]');

    if (!field) return;

    field.classList.toggle('has-date', !!input.value);
  }

  // Preferred date starts from tomorrow.
  var tomorrow = new Date();
  tomorrow.setHours(0, 0, 0, 0);
  tomorrow.setDate(tomorrow.getDate() + 1);

  var preferredMin = formatDate(tomorrow);

  preferredInput.min = preferredMin;
  alternateInput.min = preferredMin;

  // Initial helper state.
  updateDateNote(preferredInput);
  updateDateNote(alternateInput);

  preferredInput.addEventListener('change', function () {
    // Prevent today/past dates.
    if (
      preferredInput.value &&
      preferredInput.value < preferredMin
    ) {
      preferredInput.value = '';
    }

    updateDateNote(preferredInput);

    if (!preferredInput.value) {
      alternateInput.value = '';
      alternateInput.min = preferredMin;

      updateDateNote(alternateInput);
      return;
    }

    var preferredDate = new Date(
      preferredInput.value + 'T00:00:00'
    );

    // Alternate must start from the next day.
    preferredDate.setDate(preferredDate.getDate() + 1);

    var alternateMin = formatDate(preferredDate);

    alternateInput.min = alternateMin;

    // Clear Alternate if it is same as/before Preferred.
    if (
      alternateInput.value &&
      alternateInput.value < alternateMin
    ) {
      alternateInput.value = '';
    }

    updateDateNote(alternateInput);
  });

  alternateInput.addEventListener('change', function () {
    // Prevent invalid alternate date.
    if (
      alternateInput.value &&
      alternateInput.min &&
      alternateInput.value < alternateInput.min
    ) {
      alternateInput.value = '';
    }

    updateDateNote(alternateInput);
  });

  // Make the complete date field clickable.
  this.root
    .querySelectorAll('[data-cc-date-field]')
    .forEach(function (field) {
      var input = field.querySelector('input[type="date"]');

      if (!input) return;

      field.addEventListener('click', function (event) {
        input.focus();

        if (typeof input.showPicker === 'function') {
          event.preventDefault();

          try {
            input.showPicker();
          } catch (e) {
            // Native browser fallback.
          }
        }
      });
    });
};

// end by rabana

  /* NEW: panel style isn't a Shopify variant anywhere in this catalogue, so
     it just rides along as a line-item property. Always active (unlike the
     data-cc-prop fields, which setLineProperties() disables per-path). */
  CurtainConfigurator.prototype.setPanelStyle = function (style) {
    this.root.querySelectorAll('[data-cc-panel-style]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-cc-panel-style') === style);
    });
    var input = this.root.querySelector('[data-cc-panelstyle-prop]');
    if (input) input.value = style;
    var summary = this.root.querySelector('[data-cc-summary-panelstyle]');
    if (summary) summary.textContent = style;
  };

  CurtainConfigurator.prototype.setSlot = function (slot) {
    this.slot = slot;
    this.root.querySelectorAll('[data-cc-slot]').forEach(function (btn) {
      var on = btn.getAttribute('data-cc-slot') === slot;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    // Re-render so the choice reaches the line item property.
    this.render();
  };

  CurtainConfigurator.prototype.visitValue = function (key) {
    var el = this.root.querySelector('[data-cc-visit="' + key + '"]');
    return el ? el.value : '';
  };

  /* ---------------------------------------------------------------- quantity */

  CurtainConfigurator.prototype.stepQuantity = function (delta) {
    var max = this.config.maxQuantity || 10;
    this.quantity = clamp(this.quantity + delta, 1, max);
    var display = this.root.querySelector('[data-cc-qty-display]');
    if (display) display.textContent = this.quantity;
    if (this.qtyInput) this.qtyInput.value = this.quantity;
    this.render();
  };

  /* ------------------------------------------------------------------ render */

  CurtainConfigurator.prototype.selectedOptions = function () {
    var selected = [];
    this.groups.forEach(function (group) {
      var index = Number(group.getAttribute('data-cc-option-index'));
      var input = group.querySelector('[data-cc-option-input]:checked');
      if (input) selected[index] = input.value;
    });
    return selected;
  };

  CurtainConfigurator.prototype.findVariant = function (options) {
    return this.variants.find(function (variant) {
      return options.every(function (value, index) {
        return value == null || variant.options[index] === value;
      });
    });
  };

  CurtainConfigurator.prototype.render = function () {
    var selected = this.selectedOptions();
    var variant = this.findVariant(selected);
    var isStandard = this.path === 'standard';

    this.syncCardStates();
    this.syncSizePrices(selected);
    this.syncSwatchLinks(selected);

    // UPDATED: swap the main image on heading style change. Prefer an exact
    // match on every selected option (most specific photo); fall back to any
    // variant that shares just the chosen heading, so this works even when
    // only some combinations have their own photo uploaded in Shopify.
    var headingIndex = this.config.headingIndex;
    var headingValue = headingIndex >= 0 ? selected[headingIndex] : null;

    if (variant && variant.featuredMedia) {
      this.showImage(variant.featuredMedia, null, variant.featuredMediaZoom, variant.featuredMediaId);
    } else if (headingValue != null) {
      var headingMatch = this.variants.find(function (v) {
        return v.options[headingIndex] === headingValue && v.featuredMedia;
      });
      if (headingMatch) {
        this.showImage(headingMatch.featuredMedia, null, headingMatch.featuredMediaZoom, headingMatch.featuredMediaId);
      }
    }

    if (this.summaryService && this.config.serviceLabels) {
      this.summaryService.textContent = this.config.serviceLabels[this.path] || '';
    }
    if (this.summaryHeading && selected[this.config.headingIndex]) {
      this.summaryHeading.textContent = selected[this.config.headingIndex];
    }

    if (this.summarySize) {
      if (isStandard) {
        this.summarySize.textContent = selected[this.config.sizeIndex] || '';
      } else if (this.path === 'pro-measure') {
        this.summarySize.textContent = 'To be measured on site';
      } else {
        var w = this.dimensionCm('width');
        var d = this.dimensionCm('drop');
        this.summarySize.textContent = w && d ? w + ' × ' + d + ' cm' : '';
      }
    }

    // Both own-measurement paths buy the Custom variant.
    if (this.path === 'custom' || this.path === 'custom-verify') {
      this.renderMadeToMeasure(selected);
      return;
    }

    // "Measure for me" books a flat-fee visit rather than a curtain.
    if (this.path === 'pro-measure') {
      this.renderMeasureVisit();
      return;
    }

    this.setLineProperties(null);
    if (this.qtyInput) this.qtyInput.value = this.quantity;

    if (!variant) {
      this.setPrice('—');
      this.setComparePrice(0);
      this.setTotalComparePrice(0);
      this.setSubmit(false, this.config.unavailableLabel || 'Unavailable');
      return;
    }

    this.variantInput.value = variant.id;
    this.setPrice(
      formatMoney(variant.price, this.config.moneyFormat),
      formatMoney(variant.price * this.quantity, this.config.moneyFormat)
    );
    this.setComparePrice(this.computeCompareAt(variant.price));
    this.setTotalComparePrice(variant.price * this.quantity);
    this.setSubmit(
      variant.available,
      variant.available ? this.config.addLabel : this.config.soldOutLabel
    );

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  /* Custom variant for the chosen heading, dimensions on as line properties. */
  CurtainConfigurator.prototype.renderMadeToMeasure = function (selected) {
    var heading = selected[this.config.headingIndex];
    var widthCm = this.dimensionCm('width');
    var dropCm = this.dimensionCm('drop');

    var probe = [];
    probe[this.config.sizeIndex] = this.config.customSizeValue;
    probe[this.config.headingIndex] = heading;
    var variant = this.findVariant(probe);

    var price = priceCurtain(this.config.pricing, widthCm, dropCm, heading);

    // No variant or no price we trust: quote instead of selling at the
    // fail-safe price.
    if (!variant || !variant.available || price === null) {
      this.setLineProperties(null);
      this.setPrice(this.config.quoteLabel || 'Price on measurement');
      this.setComparePrice(0);
      this.setTotalComparePrice(0);
      this.setSubmit(false, this.config.quoteLabel || 'Price on measurement');
      return;
    }

    var properties = { width: widthCm, drop: dropCm };

    // UPDATED: the free confirmation visit is now an OPTIONAL add-on under
    // "custom" (no more separate "custom-verify" row in the UI). Collect the
    // date if the customer filled it in, but never require it here — only
    // the legacy "custom-verify" path (kept for backward compatibility, no
    // longer reachable from the UI) still requires a date before checkout.
    var visitApplicable = this.path === 'custom' || this.path === 'custom-verify';
    var needsVisit = this.path === 'custom-verify';
    var preferred = visitApplicable ? this.visitValue('preferred') : '';

    if (visitApplicable && preferred) {
      properties.preferred = preferred;
      properties.alternate = this.visitValue('alternate');
      properties.slot = this.slot;
    }

    this.variantInput.value = variant.id;
    this.setLineProperties(properties);

    if (needsVisit && !preferred) {
      var pendingCents = Math.round(price * 100);
      this.setPrice(
        formatMoney(pendingCents, this.config.moneyFormat),
        formatMoney(pendingCents * this.quantity, this.config.moneyFormat)
      );
      this.setComparePrice(this.computeCompareAt(pendingCents));
      this.setTotalComparePrice(pendingCents * this.quantity);
      this.setSubmit(false, this.config.needsDateLabel || 'Choose a preferred visit date');
      return;
    }

    var cents = Math.round(price * 100);
    this.setPrice(
      formatMoney(cents, this.config.moneyFormat),
      formatMoney(cents * this.quantity, this.config.moneyFormat)
    );
    this.setComparePrice(this.computeCompareAt(cents));
    this.setTotalComparePrice(cents * this.quantity);
    this.setSubmit(true, this.config.addLabel);
  };

  /* Flat fee, so the function leaves this line alone. Falls back to the
     enquiry form when no visit product is linked. */
  /* Mirrors the chosen visit date/time into the Summary panel's read-only
     rows ("Preferred date", "Alternate date", "Time of day") for the
     "Measure for me" path — the alternate-date row hides itself entirely
     when no alternate date is set, matching the real component. */
  CurtainConfigurator.prototype.syncVisitSummary = function () {
    var preferredEl = this.root.querySelector('[data-cc-summary-preferred]');
    var alternateEl = this.root.querySelector('[data-cc-summary-alternate]');
    var alternateRow = this.root.querySelector('[data-cc-summary-alternate-row]');
    var slotEl = this.root.querySelector('[data-cc-summary-slot]');

    var preferred = this.visitValue('preferred');
    var alternate = this.visitValue('alternate');

    if (preferredEl) preferredEl.textContent = preferred || 'Not set';
    if (alternateEl) alternateEl.textContent = alternate;
    if (alternateRow) alternateRow.hidden = !(this.path === 'pro-measure' && alternate);
    if (slotEl) slotEl.textContent = this.slot;
  };

  CurtainConfigurator.prototype.renderMeasureVisit = function () {
    var visit = this.config.measureVisit || {};
    var enquiry = this.root.querySelector('.cc-enquiry');
    var configured = !!visit.variantId && visit.available;

    this.syncVisitSummary();

    if (enquiry) enquiry.hidden = configured;
    if (this.submitBtn) {
  this.submitBtn.hidden = true;
}

    if (!configured) {
      this.setLineProperties(null);
      this.setPrice(this.config.quoteLabel || 'Price on measurement');
      return;
    }

    this.variantInput.value = visit.variantId;
    // Booked once, however many curtains prompted it.
    if (this.qtyInput) this.qtyInput.value = 1;

    var preferred = this.visitValue('preferred');
    this.setLineProperties({
      preferred: preferred,
      alternate: this.visitValue('alternate'),
      slot: this.slot,
      interest: this.config.productTitle
    });

    var money = formatMoney(visit.price, this.config.moneyFormat);
    this.setPrice(money, money);
    this.setSubmit(
      !!preferred,
      preferred ? this.config.bookLabel || 'Book my visit' : this.config.needsDateLabel
    );
  };

  /* Anything not passed in gets disabled, so a standard size never goes
     through carrying dimensions. Keyed by data-cc-prop. */
  CurtainConfigurator.prototype.setLineProperties = function (values) {
    var supplied = values || {};
    this.root.querySelectorAll('[data-cc-prop]').forEach(function (input) {
      var value = supplied[input.getAttribute('data-cc-prop')];
      var hasValue = value != null && String(value).trim() !== '';
      input.disabled = !hasValue;
      input.value = hasValue ? String(value) : '';
    });
  };

  CurtainConfigurator.prototype.setPrice = function (unitText, totalText) {
    this.priceEls.forEach(function (el) {
      el.textContent = unitText;
    });
    if (this.totalEl) this.totalEl.textContent = totalText || unitText;
  };

  /* Compare-at = price / discount rate, rounded to the nearest step — a
     flat 30%-off-style display on every product, not a per-variant
     merchant setting. Works on cents throughout; the rounding step is
     scaled to cents too (nearest 10 in the shop's currency = nearest 1000
     in cents). */
  CurtainConfigurator.prototype.computeCompareAt = function (priceCents) {
    if (!priceCents || priceCents <= 0) return 0;
    var rate = Number(this.config.compareDiscountRate) || 0.7;
    var stepCents = (Number(this.config.compareRoundTo) || 10) * 100;
    var raw = priceCents / rate;
    return Math.round(raw / stepCents) * stepCents;
  };

  /* cents <= 0 means "nothing real to compare against" (no compare_at_price
     set, or price unresolved) — the element is hidden entirely rather than
     showing a fabricated number, matching how a real storefront behaves. */
  CurtainConfigurator.prototype.setComparePrice = function (cents) {
    if (!this.compareEl) return;
    if (!cents || cents <= 0) {
      this.compareEl.hidden = true;
      return;
    }
    this.compareEl.textContent = formatMoney(cents, this.config.moneyFormat);
    this.compareEl.hidden = false;
  };

  /* Same idea as setComparePrice, but for the Total row's own strikethrough
     figure, computed off the actual total (unit price × quantity) rather
     than the unit price alone. */
  CurtainConfigurator.prototype.setTotalComparePrice = function (totalCents) {
    if (!this.totalCompareEl) return;
    var compareCents = this.computeCompareAt(totalCents);
    if (!compareCents) {
      this.totalCompareEl.hidden = true;
      return;
    }
    this.totalCompareEl.textContent = formatMoney(compareCents, this.config.moneyFormat);
    this.totalCompareEl.hidden = false;
  };

  CurtainConfigurator.prototype.setSubmit = function (enabled, label) {
    if (this.submitBtn) this.submitBtn.disabled = !enabled;
    if (this.submitText && label) this.submitText.textContent = label;
  };

  CurtainConfigurator.prototype.syncCardStates = function () {
    this.root.querySelectorAll('[data-cc-card]').forEach(function (card) {
      var input = card.querySelector('[data-cc-option-input]');
      card.classList.toggle('is-active', !!(input && input.checked));
    });
  };

  CurtainConfigurator.prototype.syncSizePrices = function (selected) {
    var self = this;
    var sizeIndex = this.config.sizeIndex;
    if (sizeIndex == null || sizeIndex < 0) return;

    this.root.querySelectorAll('[data-cc-size-price]').forEach(function (el) {
      var probe = selected.slice();
      probe[sizeIndex] = el.getAttribute('data-cc-size-price');

      var match = self.findVariant(probe);
      var card = el.closest('[data-cc-card]');

      if (!match) {
        el.textContent = '';
        if (card) card.classList.remove('is-unavailable');
        return;
      }

      el.textContent = formatMoney(match.price, self.config.moneyFormat);
      if (card) card.classList.toggle('is-unavailable', !match.available);
    });
  };

  CurtainConfigurator.prototype.syncSwatchLinks = function (selected) {
    var size = selected[this.config.sizeIndex];
    var heading = selected[this.config.headingIndex];

    this.root.querySelectorAll('[data-cc-swatch]').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      if (size) url.searchParams.set(SIZE_PARAM, size);
      if (heading) url.searchParams.set(HEADING_PARAM, heading);
      link.href = url.toString();
    });
  };


  CurtainConfigurator.prototype.showImage = function (src, thumb, zoomFull, mediaId) {
    var stage = this.root.querySelector('.cc-media .theme-img') || this.root.querySelector('.cc-media__stage img');
    if (!stage || !src || stage.src === src) return;
    // The theme's own image markup includes a srcset for responsive
    // sizing, and browsers prioritize srcset over src whenever both are
    // present — so just setting .src here silently does nothing until
    // srcset (and sizes, which selects among srcset candidates) are
    // cleared too, forcing the browser back onto the plain src we set.
    stage.removeAttribute('srcset');
    stage.removeAttribute('sizes');
    stage.src = src;

    if (thumb) {
      this.root.querySelectorAll('[data-cc-thumb]').forEach(function (el) {
        el.classList.toggle('is-active', el === thumb);
      });
      // A thumbnail carries its own zoom data on its attributes; an
      // explicit zoomFull/mediaId argument (from a heading-style swap)
      // always takes priority when both are somehow present.
      zoomFull = zoomFull || thumb.getAttribute('data-cc-zoom-full');
      mediaId = mediaId || thumb.getAttribute('data-cc-media-id');
    }

    // Keep the native zoom link pointed at whatever's now on screen, not
    // always the original featured image. Nothing else needs updating —
    // the theme's own 'gallery-viewer' snippet already builds its full
    // thumbnail strip from product.media independently, so every image
    // (including ones never rendered as a slide here) is already
    // click-to-zoom capable without any further JS wiring.
    if (!zoomFull || !mediaId) return;

    var zoomLink = this.root.querySelector('[data-cc-zoom-link]');
    if (zoomLink) {
      zoomLink.href = zoomFull;
      zoomLink.setAttribute('data-media-id', mediaId);
    }
    var slide = this.root.querySelector('[data-cc-slide]');
    if (slide) slide.setAttribute('data-media-id', mediaId);
  };

  /* ----------------------------------------------------------------- enquiry */

  /* On submit, so it cannot go stale. */
  CurtainConfigurator.prototype.fillEnquiry = function () {
    var self = this;
    var selected = this.selectedOptions();
    var isMeasure = this.path === 'pro-measure';
    var width = this.dimensionCm('width');
    var drop = this.dimensionCm('drop');

    var values = {
      service: (this.config.serviceLabels || {})[this.path] || this.path,
      heading: isMeasure ? '' : selected[this.config.headingIndex] || '',
      width: isMeasure || !width ? '' : String(width),
      drop: isMeasure || !drop ? '' : String(drop),
      preferred: this.visitValue('preferred'),
      alternate: this.visitValue('alternate'),
      slot: this.slot
    };

    var lines = ['Made-to-measure curtain request', 'Service: ' + values.service];
    if (values.heading) lines.push('Heading: ' + values.heading);
    if (values.width && values.drop) lines.push('Size: ' + values.width + ' × ' + values.drop + ' cm');
    if (values.preferred) lines.push('Preferred visit: ' + values.preferred);
    if (values.alternate) lines.push('Alternate visit: ' + values.alternate);
    if (values.preferred || values.alternate) lines.push('Time of day: ' + values.slot);
    values.body = lines.join('\n');

    Object.keys(values).forEach(function (key) {
      var input = self.enquiryForm.querySelector('[data-cc-enquiry="' + key + '"]');
      if (input) input.value = values[key];
    });
  };

  /* -------------------------------------------------------------------- boot */

  function init() {
    document.querySelectorAll('[data-cc-configurator]').forEach(function (root) {
      if (root.ccInitialised) return;
      root.ccInitialised = true;
      new CurtainConfigurator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();